module.exports = __webpack_public_path__ + "static/media/dailyRoutine_3_zh_HK.c1c0b4de.png";